import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useAppConfig() {

    const appConfig = useSelector<RootState, RootState["app"]["appConfig"]>(
        ({ app }) => app.appConfig
    )

    return appConfig
}
